import { ModelBasedVisual } from "./ModelBasedVisual";

export class AnimatedGLBVisual extends ModelBasedVisual {
  public getType(): string {
    return 'AnimatedGLBVisual';
  }
}   